import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.106 3.494a1 1 0 0 1 1.34-.451 10 10 0 1 1-8.895.001 1 1 0 1 1 .89 1.791 8 8 0 1 0 7.116 0 1 1 0 0 1-.451-1.341",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0z" })
);
var SvgPowerOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PowerOutlined_default = SvgPowerOutlined;

export { PowerOutlined_default as default };
